export const currencyOptions = [
  { label: 'DOP', value: '1' },
  { label: 'INR', value: '2' },
  { label: 'MXN', value: '3' },
  { label: 'USD', value: '4' },
  { label: 'YEN', value: '5' },
];
